export const GET_EXCEPTION_REPORT_CONFIG_LIST = 'GET_EXCEPTION_REPORT_CONFIG_LIST';
export const SET_EXCEPTION_REPORT_CONFIG_LIST = 'SET_EXCEPTION_REPORT_CONFIG_LIST';
export const DELETE_EXCEPTION_REPORT_CONFIG = 'DELETE_EXCEPTION_REPORT_CONFIG';
export const SAVE_EXCEPTION_REPORT_CONFIG = 'SAVE_EXCEPTION_REPORT_CONFIG';
